import { isEastTerritory } from 'common/utils/checkTerritory';

export const WEST_CARD_NAME = 'E100';
export const EAST_CARD_NAME = 'E1 CARD';

export const CARD_NAME = isEastTerritory ? EAST_CARD_NAME : WEST_CARD_NAME;
